(function () {
    $.get("https://ipinfo.io/json", function (response) {
        /* PT ES FR */
        var all_countries = ['PT', 'ES', 'FR', 'BE', 'CH', 'LU', 'MC']
        var data = sessionStorage.getItem('country_store');
        
        switch (data) {
            case 'PT':
                // directUser(response, data);
                break;
            
            case 'ES':
                // directUser(response, data);
                break;
            
            case 'FR':
                // directUser(response, data);
                break;
            
            case 'EU':
                // directUser(response, data);
                break;
            
            default:
                launchModal(response, data);
        }
        
    });
    
    function launchModal(response, data) {
        var all_countries = ['PT','ES','FR','BE','CH','LU','MC']
        var franc_countries = ['FR', 'BE', 'CH', 'LU', 'MC']
        var user_country = '';
        var store_data = JSON.parse(document.getElementById("Store_Modal--Data").innerText);
        var current_store = store_data.c_store;
        var display_modal = true;

        if (franc_countries.includes(response.country)) {
            user_country = 'FR';
        } else if (all_countries.includes(response.country)) {
            user_country = response.country;
        } else {
            user_country = 'EU';
        }

        if ( current_store == user_country ) {
            display_modal = false;
        }

        if ((response.country != current_store) && (data != user_country) && display_modal) {
            var modal = document.getElementById("shopify-section-geolocation");
            var modal_wrapper = document.querySelector(".store_modal--wrapper");
            var span = document.getElementsByClassName("store_modal--close")[0];
            var store_link = document.getElementsByClassName("button--flag");

            modal.style.display = "block";
            modal.style.height = "100%";
            modal.style.width = "100%";
            modal.style.contentVisibility = "auto";
            modal_wrapper.style.display = "block";
            modal_wrapper.style.contentVisibility = "auto";
            span.onclick = function () {
                modal.style.display = "none";
                modal.style.height = "0";
                modal.style.width = "0";
                modal.style.contentVisibility = "hidden";
                modal_wrapper.style.display = "none";
                modal_wrapper.style.contentVisibility = "hidden";
                sessionStorage.setItem('country_store', current_store);
            }
    
            modal.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                    modal.style.height = "0";
                    modal.style.width = "0";
                    modal.style.contentVisibility = "hidden";
                    modal_wrapper.style.display = "none";
                modal_wrapper.style.contentVisibility = "hidden";
                }
            }
        }
        
        var current_store_name = store_data[current_store].name;
        var current_store_url = store_data[current_store].url;
        var current_store_flag = store_data[current_store].rec_flag;
        var current_store_flag_srcset = store_data[current_store].rec_flag_srcset;
        
        var user_country_name = store_data[user_country].name;
        var user_country_url = store_data[user_country].url;
        var user_country_flag = store_data[user_country].rec_flag;
        var user_country_flag_srcset = store_data[user_country].rec_flag_srcset;
        var user_country_title = store_data[user_country].title;
        var user_country_subtitle = store_data[user_country].subtitle;
        var user_country_description = store_data[user_country].description;
        var user_country_stay_cta = store_data[user_country].yes;
        var user_country_go_cta = store_data[user_country].no;

        document.getElementById('Store_Modal--Title').innerHTML += user_country_title;
        document.getElementById('Store_Modal--Subtitle').innerHTML += user_country_subtitle;
        document.getElementById('Store_Modal--Description').innerHTML += user_country_description;
        document.getElementById('Store_Modal--Locations').innerHTML += '<span id="' + current_store + '"href="' + current_store_url + '" class="button--flag" onclick="stayLocation(this.id)"><img src="' + current_store_flag + '" srcset="' + current_store_flag_srcset + ' 2x">' + user_country_stay_cta + '</span>';
        document.getElementById('Store_Modal--Locations').innerHTML += '<span id="' + user_country + '"href="' + user_country_url + '" class="button--flag" onclick="directLocation(this.id)"><img src="' + user_country_flag + '" srcset="' + user_country_flag_srcset + ' 2x">' + user_country_go_cta + '</span>';
    }

    function directUser(response, data) {
        var user_country = '';
        var store_data = JSON.parse(document.getElementById("Store_Modal--Data").innerText);
        var current_store = store_data.c_store;

        if (data != current_store) {

            var franc_countries = ['FR', 'BE', 'CH', 'LU', 'MC']
            if (franc_countries.includes(response.country)) {
                user_country = 'FR';
            } else {
                user_country = response.country;
            }

            window.location.replace(store_data[data].url);

        }
    }
})($);